import { render, staticRenderFns } from "./informes.vue?vue&type=template&id=c2da9760&scoped=true"
import script from "./informes.vue?vue&type=script&lang=js"
export * from "./informes.vue?vue&type=script&lang=js"
import style0 from "./informes.vue?vue&type=style&index=0&id=c2da9760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2da9760",
  null
  
)

export default component.exports